import parseNumber from "@toolkit/Framework/Common/Utilities/parseNumber";

export enum Operators {
    Add,
    Substract,
    Divide,
    Multiply,
}

const getUpdatedValue = (value: number, operator: Operators, amount: number) => {
    switch (operator) {
        case Operators.Add:
            return value + amount;
        case Operators.Substract:
            return value - amount;
        case Operators.Divide:
            return value / amount;
        case Operators.Multiply:
            return value * amount;
        default:
            return value;
    }
};

export default (initialValue: string | 0 | null, operator: Operators, amount: number) => {
    if (initialValue !== null) {
        if (typeof initialValue === "number") {
            return `${getUpdatedValue(initialValue, operator, amount)}`;
        }

        const value = parseNumber(initialValue);
        if (value !== null) {
            return `${getUpdatedValue(Math.abs(value), operator, amount)}${/[a-zA-Z]+$/.exec(initialValue)}`;
        }
    }

    return null;
};
